import {
    GET_PROJECT_REFERENCES_OF_TABLE,
    GET_TABLE_DETAILS_FOR_DATA_BROWSER,
    LOAD_TABLE_DETAILS,
    GET_DOWNSTREAM_REFERENCES
} from './types.js';

export const doLoadTableDetails = ({ database, schema, table }) => ({
    type: LOAD_TABLE_DETAILS,
    api: { version: 2, name: 'GetTableDetails' },
    params: { database, schema, table }
});

export const doGetProjectReferencesOfTable = ({ database, schema, table }) => ({
    type: GET_PROJECT_REFERENCES_OF_TABLE,
    api: { version: 2, name: 'GetProjectReferences' },
    params: { database, schema, table }
});

export const doGetTableDetailsForDataBrowser = ({ tables }) => ({
    type: GET_TABLE_DETAILS_FOR_DATA_BROWSER,
    api: { version: 2, name: 'GetTableDetailsForDataBrowser' },
    params: { tables }
});

export const doGetDownstreamReferences = (fqn) => ({
    type: GET_DOWNSTREAM_REFERENCES,
    api: { version: 2, name: 'GetDownstreamReferences' },
    params: fqn
});
